'use client';

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@/components/ui/card';
import { Star, ThumbsUp, Settings, TrendingUp } from 'lucide-react';
import { useTranslations } from 'next-intl';
export default function FeaturesSection() {
  const $ = _c(53);
  const t = useTranslations("Features");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative flex aspect-square size-16 rounded-full bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50 mb-6"><Star className="m-auto size-8 text-black" strokeWidth={1.5} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("passion.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h2 className="text-3xl font-semibold mb-3 font-[family-name:var(--font-bebas-neue)] break-words hyphens-auto">{t1}</h2>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("passion.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="text-foreground leading-relaxed">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <Card className="relative overflow-hidden"><CardContent className="pt-6">{t0}{t2}{t4}</CardContent></Card>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative flex aspect-square size-16 rounded-full bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50 mb-6"><ThumbsUp className="m-auto size-8 text-black" strokeWidth={1.5} /></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("humanSize.title");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <h2 className="text-3xl font-semibold mb-3 font-[family-name:var(--font-bebas-neue)] break-words hyphens-auto">{t7}</h2>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("humanSize.description");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <p className="text-foreground leading-relaxed">{t9}</p>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <Card className="relative overflow-hidden"><CardContent className="pt-6">{t6}{t8}{t10}</CardContent></Card>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="relative flex aspect-square size-16 rounded-full bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50 mb-6"><Settings className="m-auto size-8 text-black" strokeWidth={1.5} /></div>;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("personalizedSetup.title");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <h2 className="text-3xl font-semibold mb-3 font-[family-name:var(--font-bebas-neue)] break-words hyphens-auto">{t13}</h2>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("personalizedSetup.description");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <p className="text-foreground leading-relaxed">{t15}</p>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <Card className="relative overflow-hidden"><CardContent className="pt-6">{t12}{t14}{t16}</CardContent></Card>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="relative flex aspect-square size-16 rounded-full bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50 mb-6"><TrendingUp className="m-auto size-8 text-black" strokeWidth={1.5} /></div>;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("progressionAdvice.title");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19) {
    t20 = <h2 className="text-3xl font-semibold mb-3 font-[family-name:var(--font-bebas-neue)] break-words hyphens-auto">{t19}</h2>;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t("progressionAdvice.description");
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t21) {
    t22 = <p className="text-foreground leading-relaxed">{t21}</p>;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t20 || $[46] !== t22) {
    t23 = <Card className="relative overflow-hidden"><CardContent className="pt-6">{t18}{t20}{t22}</CardContent></Card>;
    $[45] = t20;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t11 || $[49] !== t17 || $[50] !== t23 || $[51] !== t5) {
    t24 = <section className="py-16 md:py-32 -mt-48"><div className="mx-auto max-w-7xl px-4 sm:px-6"><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">{t5}{t11}{t17}{t23}</div></div></section>;
    $[48] = t11;
    $[49] = t17;
    $[50] = t23;
    $[51] = t5;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  return t24;
}